import React from "react";
import "./Contact.css";
import axios from "axios";
import { useState } from "react";
import ManualAlertpage from "../Alert/ManualAlertpage";

const ApplyCourseSmall = () => {

  // form submission 

  const [submissionpage, setsubmissionpage] = useState(false); // for enable Submission page 
  const [Submissiondata, setSubmissiondata] = useState({})

  const toggleFn = () => {
    setsubmissionpage(!submissionpage);
  }

  const [error, seterror] = useState("")
  const [loader, setloader] = useState(false)
  const [data, setData] = useState({
    fullname: "", number: "", email: "", course: "", message: ""
  })

  const handlechange = async (e) => {
    const { name, value } = e.target
    setData({ ...data, [name]: value })
  }

  const handleerror = () => {
    let validate = true

    if (data.number.length != 10) {
      seterror("Number must in 10 digits")
      validate = false
    }
    return validate
  }

  const handlesubmit = async (e) => {
    e.preventDefault()
    console.log("sending data", data)
    if (handleerror()) {
      setloader(true)
      seterror("")

      try {
        const response = await fetch("https://icoeess-backend-06-feb-2025-icoessbackend.onrender.com/api/applyinquiry", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(data)
        });

        const result = await response.json()

        if (result.status == "success") {
          setsubmissionpage(true)
          setSubmissiondata({
            message: "Thank you for enquiring us!!",
            context: `A confirmation E-mail has been sent on <strong>${data.email}</strong>. We will be in touch with you shortly.`,
            btnname: "Ok"
          })
          setData({ fullname: "", number: "", email: "", course: "" })
        }
        else {
          seterror("Something else please try again!")
        }
      } catch (err) {
        seterror("There was an error while submitting your application. Please try again.");
        console.error("Fetching Error:", err);
      } finally {
        setloader(false)
      }
    }
  }

  if (loader) {
    return <p style={{ fontSize: "2rem", margin: "auto" }}>Loading...</p>
  }
  return (
    <>
      <section className="apply-job" style={{ position: "relative" }}>
        <div className="contact-card">
          <div className="center column">
            <h2 className="heading2">Free Career Counselling</h2>
            <p className="para2">
              Dont be shy let us know if you have any questions
            </p>
            <form action="POST" className="contact-form" onSubmit={handlesubmit}>
              <input type="text" placeholder="Full Name" name="fullname" id="" onChange={handlechange} value={data.fullname} required />
              <input type="number" placeholder="Mobile Number" name="number" id="" onChange={handlechange} value={data.number} required />
              <input type="email" placeholder="Email" name="email" id="" onChange={handlechange} value={data.email} required />
              <select name="course" id="course" onChange={handlechange} value={data.course} required>
                <option value="" disabled>Select Course</option>
                <option value="Full Stack Web Development">Full Stack Web Development</option>
                <option value="AI & ML">AI & ML</option>
                <option value="Java Full Stack">Java Full Stack</option>
                <option value="Cloud Architect & AWS">Cloud Architect & AWS</option>
                <option value="Python & Data Science">Python & Data Science</option>
                <option value="DevOps">DevOps</option>
              </select>
              <textarea type="text" placeholder="(Optional) Type message here..." name="message" onChange={handlechange} value={data.message} ></textarea>
              {error && <p className="error-textapply">{error}</p>}

              <button type="submit" className={"cta"}>
                Submit
              </button>
            </form>
          </div>
        </div>
        {submissionpage &&
          <ManualAlertpage
            message={Submissiondata.message}
            context={Submissiondata.context}
            context2={Submissiondata.context2}
            btnname={Submissiondata.btnname}
            close={submissionpage}
            togglebox={toggleFn} />
        }
      </section>
    </>
  );
};

export default ApplyCourseSmall;
